import { MapProperties } from '@datum-group/datum-map/lib';
import {
  createLayerStyleFunction,
  setStyle,
} from '@datum-group/datum-map/lib/Layer/StyleUtils/styleParsing';
import { ZINDEX } from '@project/components/Map/constants';
import {
  CartogramStyleSettings,
  createCartogramFeatures,
  createCartogramStyle,
} from '@project/components/Module/Cartograms';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

export const CARTOGRAM_LAYER_NAME = 'cartogram_layer';

export class CartogramsMapControllerStore {
  private _mapProperties: MapProperties;

  constructor(mapProperties: MapProperties) {
    this._mapProperties = mapProperties;
  }

  createLayer = () => {
    const initLayer = new VectorLayer({
      source: new VectorSource(),
      zIndex: ZINDEX.CARTOGRAM,
    });
    initLayer.setProperties({ name: CARTOGRAM_LAYER_NAME });
    this._mapProperties.map.addLayer(initLayer);
  };

  getLayer = () => {
    const cartogramLayer = this._mapProperties.map
      .getLayers()
      .getArray()
      .find(
        (layer) => layer.get('name') === CARTOGRAM_LAYER_NAME,
      ) as VectorLayer;

    if (!cartogramLayer) throw new Error('Слоя картограмм не существует');

    return cartogramLayer;
  };

  getFeatures = () => {
    const layer = this.getLayer();
    const source = layer.getSource();

    if (!source) return [];

    return source.getFeatures();
  };

  setFeatures = (cartogramFeatures: GeoJSON.Feature[]) => {
    const layer = this.getLayer();
    const features = createCartogramFeatures(cartogramFeatures);
    const source = layer.getSource();

    if (!source) return;

    source.clear();
    source.addFeatures(features);
  };

  setStyle = (styleSettings: CartogramStyleSettings = {}) => {
    const layer = this.getLayer();
    setStyle(
      layer,
      createCartogramStyle(styleSettings),
      this._mapProperties.map,
    );
  };

  setStyleFunction = (styleSettings: CartogramStyleSettings) => {
    const layer = this.getLayer();
    const style = createCartogramStyle(styleSettings);
    const styleFunction = createLayerStyleFunction(
      style,
      layer,
      this._mapProperties.map,
    );
    layer.setStyle(styleFunction);
  };

  removeCartogramLayer = () => {
    const layer = this.getLayer();
    this._mapProperties.map.removeLayer(layer);
  };
}
